import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from './appsettings.service';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

    constructor(
        private authService: AdalService,
        private appSettingsService: AppSettingsService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (this.authService.userInfo.isAuthenticated) {
            return new Promise((res) => { res(); }).then(() => { return true; });
        }

        return this.appSettingsService.getAppSettings().then(() => { return true });
    }
}


/** WEBPACK FOOTER **
 ** ./app/services/authguard.service.ts
 **/